import script from "./SkeletItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletItem.vue?vue&type=script&setup=true&lang=js"

import "./SkeletItem.vue?vue&type=style&index=0&id=7230de07&lang=scss"

const __exports__ = script;

export default __exports__